'use es6';

import styled from 'styled-components';
const BORDER_COLOR = '#99acc2';
export const StyledThead = styled.thead.withConfig({
  displayName: "CrossTabStyledComponents__StyledThead",
  componentId: "sc-19k6gt7-0"
})(["border-top:0.5px solid ", ";"], BORDER_COLOR);
export const StyledTh = styled.th.withConfig({
  displayName: "CrossTabStyledComponents__StyledTh",
  componentId: "sc-19k6gt7-1"
})(["&&{height:22px;text-align:", ";border-radius:0 !important;border:0.5px solid ", ";background-color:", " !important;padding-block:", ";}"], ({
  textAlign
}) => textAlign, ({
  theme
}) => theme.color['text-primary-disabled'], ({
  theme
}) => theme.color['fill-primary-disabled'], ({
  theme
}) => theme.space['200']);
export const StyledTd = styled.td.withConfig({
  displayName: "CrossTabStyledComponents__StyledTd",
  componentId: "sc-19k6gt7-2"
})(["&&{text-align:", ";height:22px;min-width:120px;border-radius:0 !important;border:0.5px solid ", " !important;", "}"], ({
  textAlign
}) => textAlign, ({
  theme
}) => theme.color['text-primary-disabled'], ({
  isRowHeader,
  theme
}) => isRowHeader && `background-color:
        ${theme.color['fill-surface-raised']} !important`);